const GLOBAL_TO_LOCAL_HOST: Record<string, string> = {
  'dev-global.myeztopup.com': 'dev.myeztopup.com',
  'global.myeztopup.com': 'eztopup.com.mm',
};

const LOCAL_TO_GLOBAL_HOST: Record<string, string> = {
  'dev.myeztopup.com': 'dev-global.myeztopup.com',
  'myeztopup.com': 'global.myeztopup.com',
  'eztopup.com.mm': 'global.myeztopup.com',
};

const GLOBAL_HOSTS = new Set(Object.keys(GLOBAL_TO_LOCAL_HOST));
const LOCAL_HOSTS = new Set([
  ...Object.values(GLOBAL_TO_LOCAL_HOST),
  ...Object.keys(LOCAL_TO_GLOBAL_HOST),
]);

export const MYANMAR_TIMEZONE = 'Asia/Yangon';

export const normalizeHostname = (hostname = window.location.hostname) =>
  hostname
    .trim()
    .toLowerCase()
    .replace(/^www\./, '');

export const isGlobalSiteHost = (hostname = window.location.hostname) =>
  GLOBAL_HOSTS.has(normalizeHostname(hostname));

export const isLocalMyanmarSiteHost = (hostname = window.location.hostname) =>
  LOCAL_HOSTS.has(normalizeHostname(hostname));

export const getMyanmarRedirectHost = (hostname = window.location.hostname) =>
  GLOBAL_TO_LOCAL_HOST[normalizeHostname(hostname)] ?? null;

export const getGlobalRedirectHost = (hostname = window.location.hostname) =>
  LOCAL_TO_GLOBAL_HOST[normalizeHostname(hostname)] ?? null;

export const getUserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
};

export const isUserInMyanmarTimezone = () => getUserTimezone() === MYANMAR_TIMEZONE;

export const buildMyanmarSiteRedirectUrl = (location: Location = window.location) => {
  const redirectHost = getMyanmarRedirectHost(location.hostname);
  if (!redirectHost) return null;

  const target = new URL(location.href);
  target.hostname = redirectHost;
  target.protocol = 'https:';
  target.port = '';
  return target.toString();
};

export const buildGlobalSiteRedirectUrl = (location: Location = window.location) => {
  const redirectHost = getGlobalRedirectHost(location.hostname);
  if (!redirectHost) return null;

  const target = new URL(location.href);
  target.hostname = redirectHost;
  target.protocol = 'https:';
  target.port = '';
  return target.toString();
};
